import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Pusher extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleSocket = this.handleSocket.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    const { socket } = this.context;
    const { event } = this.props;
    socket.on(event, this.handleSocket);
  }
  componentWillReceiveProps(nextProps) {
    const { socket } = this.context;
    if (this.props.event !== nextProps.event) {
      socket.off(this.props.event, this.handleSocket);
      socket.on(nextProps.event, this.handleSocket);
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    const { socket } = this.context;
    const { event } = this.props;
    socket.off(event, this.handleSocket);
  }

  handleSocket(...args) {
    this.props.handler(...args);
  }
  render() {
    return null;
  }
}

Pusher.propTypes = {
  event: PropTypes.string.isRequired,
  handler: PropTypes.func.isRequired,
};

Pusher.defaultProps = {
};
Pusher.contextTypes = {
  socket: PropTypes.shape({}).isRequired,
};

export default Pusher;
